<template>
    <div class="modal fade modern-modal" tabindex="-1" id="CadastroCertificadoAssinatura" ref="modalCadastroCertificadoAssinatura">
        <div class="modal-dialog modal-dialog-centered modal-xl modal-modern">
            <div class="modal-content modal-modern-content border-0">
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                        data-bs-dismiss="modal"
                        type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>

                <div class="modal-modern-header">
                    <div class="header-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M21.7 13.58L20.42 12.3C20.21 12.09 19.86 12.09 19.65 12.3L18.65 13.3L20.7 15.35L21.7 14.35C21.91 14.14 21.91 13.79 21.7 13.58M12 22H14.06L20.11 15.93L18.06 13.88L12 19.94V22M10 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 4.47 3.21 3.96 3.59 3.59C3.96 3.21 4.47 3 5 3H19C20.1 3 21 3.89 21 5V10.33C20.36 10.07 19.63 10.08 19 10.36V5H5V19H10.11L10 19.11V21M14.62 14.5L12.11 17H7.5V16.25C7.5 14.75 10.5 14 12 14C12.7 14 13.73 14.16 14.62 14.5M13.59 11.59C13.17 12 12.6 12.25 12 12.25C11.4 12.25 10.83 12 10.41 11.59C10 11.17 9.75 10.6 9.75 10C9.75 9.4 10 8.83 10.41 8.41C10.83 8 11.4 7.75 12 7.75C12.6 7.75 13.17 8 13.59 8.41C14 8.83 14.25 9.4 14.25 10C14.25 10.6 14 11.17 13.59 11.59Z" />
                        </svg>
                    </div>
                    <div class="header-text">
                        <h2>Gerenciar certificados</h2>
                        <p>Cadastre os dados do responsável e acompanhe os certificados emitidos no contrato.</p>
                    </div>
                </div>

                <div class="modal-modern-body">
                    <div class="tab-wrapper">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link"
                                        :class="{ active: abaModalAtiva === 'Cadastro' }"
                                        @click="setAba('Cadastro')"
                                        type="button">
                                    Cadastro
                                </button>
                            </li>

                            <li class="nav-item" role="presentation">
                                <button class="nav-link"
                                        :class="{ active: abaModalAtiva === 'Certificados', disabled: !temPessoa }"
                                        @click="setAba('Certificados')"
                                        type="button"
                                        :disabled="!temPessoa"
                                        :aria-disabled="!temPessoa"
                                        :tabindex="!temPessoa ? -1 : 0"
                                        title="Cadastre/recupere a pessoa para habilitar esta aba">
                                    Certificados
                                </button>
                            </li>
                        </ul>

                        <div v-if="abaModalAtiva === 'Cadastro'" class="cadastro-card">
                            <form id="formCadastroCertificadoAssinatura" v-if="dados" class="modal-form" novalidate>
                                <div class="form-grid form-grid-2">
                                    <div class="form-group">
                                        <label class="form-label">Email</label>
                                        <input v-model="novaPessoa.dsEmail"
                                               type="text"
                                               class="form-control"
                                               :class="{ 'border-danger': camposInvalidos.dsEmail || emailInternoConflito }"
                                               placeholder="Digite o email"
                                               @blur="validarEmailInterno" />
                                        <small v-if="emailInternoConflito"
                                               class="text-danger d-block mt-1">
                                            Este e-mail já está cadastrado como um usuário do sistema.
                                            Para gerar ou gerenciar o certificado, use a aba
                                            <strong>"Gerenciamento de Usuários"</strong>.
                                        </small>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Nome</label>
                                        <input v-model="novaPessoa.nmPessoa"
                                               type="text"
                                               class="form-control"
                                               :class="{ 'border-danger': camposInvalidos.nmPessoa }"
                                               placeholder="Digite o nome completo" />
                                    </div>
                                </div>

                                <div class="form-grid form-grid-2">
                                    <div class="form-group">
                                        <label class="form-label">CPF/CNPJ</label>
                                        <input v-model="novaPessoa.nrCpfCnpj"
                                               @input="formatarCpfCnpj"
                                               :maxlength="18"
                                               inputmode="text"
                                               autocomplete="off"
                                               type="text"
                                               class="form-control"
                                               :class="{ 'border-danger': camposInvalidos.nrCpfCnpj }"
                                               placeholder="Digite o CPF ou CNPJ" />
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">RG</label>
                                        <input v-model="novaPessoa.nrRg"
                                               @input="sanitizarRg"
                                               :maxlength="rgMaxLength"
                                               type="text"
                                               class="form-control"
                                               :class="{ 'border-danger': camposInvalidos.nrRg }"
                                               placeholder="Digite o RG" />
                                    </div>
                                </div>

                                <div class="form-grid form-grid-2">
                                    <div class="form-group">
                                        <label class="form-label">Data de nascimento</label>
                                        <input type="date"
                                               class="form-control"
                                               :class="{ 'border-danger': camposInvalidos.dtNascimento }"
                                               v-model="novaPessoa.dtNascimento"
                                               :max="maxNascimentoISO"
                                               :min="minNascimentoISO"
                                               required
                                               lang="pt-BR"
                                               inputmode="numeric" />
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">País</label>
                                        <input v-model="novaPessoa.nmPais"
                                               type="text"
                                               class="form-control"
                                               :class="{ 'border-danger': camposInvalidos.nmPais }"
                                               placeholder="Digite o país de residência" />
                                    </div>
                                </div>

                                <div class="form-grid form-grid-2">
                                    <div class="form-group">
                                        <label class="form-label">Estado</label>
                                        <select v-model="novaPessoa.nmUf"
                                                class="form-control"
                                                :class="{ 'border-danger': camposInvalidos.nmUf }"
                                                required>
                                            <option disabled value="">Selecione o estado</option>
                                            <option v-for="uf in ufs" :key="uf.sigla" :value="uf.sigla">
                                                {{ uf.nome }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Cidade</label>
                                        <input v-model="novaPessoa.nmCidade"
                                               type="text"
                                               class="form-control"
                                               :class="{ 'border-danger': camposInvalidos.nmCidade }"
                                               placeholder="Digite a cidade de residência" />
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div v-if="abaModalAtiva === 'Certificados'" class="px-3 pb-3 certificados-wrapper">
                            <div class="section-card">

                                <div class="alert alert-warning mb-3" v-if="!temPessoa || !novaPessoa.idPessoa">
                                    <i class="fa fa-info-circle me-2"></i>
                                    <strong>Indisponível:</strong> cadastre/recupere a pessoa antes de gerar o certificado.
                                </div>

                                <div class="d-flex gap-2">
                                    <button class="btn btn-fluxo btn-acoes"
                                            type="button"
                                            @click="gerarCertificado"
                                            :disabled="isGerandoCert || !temPessoa || !novaPessoa.idPessoa || hasCertAtivo"
                                            :title="hasCertAtivo ? 'Já existe um certificado ativo para esta pessoa' : 'Gerar e salvar certificado para esta pessoa'">
                                        <span v-if="!isGerandoCert"><i class="fa fa-award cert-icon me-2"></i>Gerar Certificado</span>
                                        <span v-else><i class="fa fa-spinner fa-spin me-2"></i>Gerando...</span>
                                    </button>
                                </div>
                            </div>
                            <div class="mt-3">
                                <div v-if="isLoadingCerts" class="text-muted">
                                    <i class="fa fa-spinner fa-spin me-2"></i>Carregando certificados...
                                </div>

                                <div v-else-if="certsError" class="alert alert-danger">
                                    {{ certsError }}
                                </div>

                                <div v-else-if="certificados.length === 0" class="text-muted">
                                    Nenhum certificado encontrado para esta pessoa.
                                </div>

                                <div v-else class="cert-grid">
                                    <div v-for="(c, idx) in certificados"
                                         :key="c.idPessoaInstituicaoCertificado || idx"
                                         class="cert-card"
                                         :class="{ 'ativo': c.flAtivo }">

                                        <div class="cert-card-header">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="d-flex align-items-center gap-2">
                                                    <i class="fa fa-award cert-icon" :class="c.flAtivo ? 'text-success' : 'text-muted'"></i>
                                                    <span :class="c.flAtivo ? 'badge-status badge-status-active' : 'badge-status badge-status-revoked'">
                                                        {{ c.flAtivo ? 'Ativo' : 'Revogado' }}
                                                    </span>
                                                </div>

                                                <button v-if="c.flAtivo"
                                                        class="btn-revogar"
                                                        :disabled="isRevogandoId === c.idPessoaInstituicaoCertificado"
                                                        @click="revogarCertificado(c)"
                                                        title="Revogar este certificado">
                                                    <i v-if="isRevogandoId !== c.idPessoaInstituicaoCertificado" class="fa fa-ban me-1"></i>
                                                    <i v-else class="fa fa-spinner fa-spin me-1"></i>
                                                    Revogar
                                                </button>
                                            </div>
                                        </div>

                                        <div class="cert-fields">
                                            <div class="pair pair-full">
                                                <small class="lbl"><i class="fa fa-user me-1"></i>Nome</small>
                                                <div class="val" :title="c.nmPessoa || '-'">{{ c.nmPessoa || '-' }}</div>
                                            </div>

                                            <div class="pair pair-full">
                                                <small class="lbl"><i class="fa fa-envelope me-1"></i>E-mail</small>
                                                <div class="val" :title="c.dsEmail || '-'">{{ c.dsEmail || '-' }}</div>
                                            </div>

                                            <div class="pair">
                                                <small class="lbl"><i class="fa fa-id-card me-1"></i>CPF/CNPJ</small>
                                                <div class="val">{{ maskCpfCnpj(c.nrCpfCnpj || '') }}</div>
                                            </div>

                                            <div class="pair">
                                                <small class="lbl"><i class="fa fa-address-card me-1"></i>RG</small>
                                                <div class="val">{{ c.nrRg || '-' }}</div>
                                            </div>

                                            <div class="pair">
                                                <small class="lbl"><i class="fa fa-calendar me-1"></i>Data de Nascimento</small>
                                                <div class="val">{{ formatDate(c.dtNascimento) }}</div>
                                            </div>

                                            <div class="pair">
                                                <small class="lbl"><i class="fa fa-map-marker-alt me-1"></i>Estado</small>
                                                <div class="val">{{ (c.nmUf || '').toUpperCase() || '-' }}</div>
                                            </div>

                                            <div class="pair">
                                                <small class="lbl"><i class="fa fa-city me-1"></i>Cidade</small>
                                                <div class="val" :title="c.nmCidade || '-'">{{ c.nmCidade || '-' }}</div>
                                            </div>

                                            <div class="pair">
                                                <small class="lbl"><i class="fa fa-globe me-1"></i>País</small>
                                                <div class="val">{{ c.nmPais || '-' }}</div>
                                            </div>

                                            <div class="cert-divider"></div>

                                            <div class="pair pair-full pair-meta">
                                                <small class="lbl"><i class="fa fa-user-plus me-1"></i>Criado por</small>
                                                <div class="val-meta">
                                                    <span class="meta-name">{{ c.nmCriadoPor }}</span>
                                                    <span v-if="c.dtInclusao" class="meta-date">{{ formatDateTime(c.dtInclusao) }}</span>
                                                </div>
                                            </div>

                                            <div class="pair pair-full pair-meta" v-if="!c.flAtivo">
                                                <small class="lbl"><i class="fa fa-user-times me-1"></i>Revogado por</small>
                                                <div class="val-meta">
                                                    <span class="meta-name">{{ c.nmRevogadoPor }}</span>
                                                    <span v-if="c.dtAlteracao" class="meta-date">{{ formatDateTime(c.dtAlteracao) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="modal-modern-footer" v-if="abaModalAtiva === 'Cadastro'">
                    <button class="btn btn-modern-primary w-100" type="button" @click="enviar">
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import Swal from 'sweetalert2'

    export default {
        name: 'CadastroCertificadoAssinatura',
        components: {

        },
        data: function () {
            return {

                limiteCaracteres: 500,
                abaModalAtiva: 'Cadastro',
                temPessoa: false,
                novaPessoa: {
                    idPessoa: null,
                    dsEmail: '',
                    nrCpfCnpj: '',
                    nrRg: '',
                    nmPessoa: '',
                    dtNascimento: '',
                    nmCidade: '',
                    nmUf: '',
                    nmPais: '',
                },
                camposInvalidos: {
                    dsEmail: false,
                    nrCpfCnpj: false,
                    nrRg: false,
                    nmPessoa: false,
                    dtNascimento: false,
                    nmCidade: false,
                    nmUf: false,
                    nmPais: false,
                },
                rgMaxLength: 12,
                isGerandoCert: false,
                isRevogandoId: null,
                ufs: [
                    { sigla: 'AC', nome: 'Acre' },
                    { sigla: 'AL', nome: 'Alagoas' },
                    { sigla: 'AP', nome: 'Amapá' },
                    { sigla: 'AM', nome: 'Amazonas' },
                    { sigla: 'BA', nome: 'Bahia' },
                    { sigla: 'CE', nome: 'Ceará' },
                    { sigla: 'DF', nome: 'Distrito Federal' },
                    { sigla: 'ES', nome: 'Espírito Santo' },
                    { sigla: 'GO', nome: 'Goiás' },
                    { sigla: 'MA', nome: 'Maranhão' },
                    { sigla: 'MT', nome: 'Mato Grosso' },
                    { sigla: 'MS', nome: 'Mato Grosso do Sul' },
                    { sigla: 'MG', nome: 'Minas Gerais' },
                    { sigla: 'PA', nome: 'Pará' },
                    { sigla: 'PB', nome: 'Paraíba' },
                    { sigla: 'PR', nome: 'Paraná' },
                    { sigla: 'PE', nome: 'Pernambuco' },
                    { sigla: 'PI', nome: 'Piauí' },
                    { sigla: 'RJ', nome: 'Rio de Janeiro' },
                    { sigla: 'RN', nome: 'Rio Grande do Norte' },
                    { sigla: 'RS', nome: 'Rio Grande do Sul' },
                    { sigla: 'RO', nome: 'Rondônia' },
                    { sigla: 'RR', nome: 'Roraima' },
                    { sigla: 'SC', nome: 'Santa Catarina' },
                    { sigla: 'SP', nome: 'São Paulo' },
                    { sigla: 'SE', nome: 'Sergipe' },
                    { sigla: 'TO', nome: 'Tocantins' },
                ],
                certificados: [],
                isLoadingCerts: false,
                certsError: null,
                emailInternoConflito: false,
                modal: null,
            }
        },
        props: {
            showModal: Boolean,
            dados: Object,
            alvo: { type: String, default: 'usuario' },
            emailsInternos: { type: Array, default: () => [] },
        },
        computed: {
            maxNascimentoISO() {
                return moment().subtract(14, 'years').format('YYYY-MM-DD')
            },

            minNascimentoISO() {
                return '1900-01-01'
            },

            hasCertAtivo() {
                return Array.isArray(this.certificados) && this.certificados.some(c => c.flAtivo === true);
            },

        },
        methods: {
            toISODateOnly(v) {
                if (!v) return ''
                let m = moment(v, moment.ISO_8601, true)
                if (!m.isValid() && typeof v === 'string' && v.includes('/')) {
                    m = moment(v, 'DD/MM/YYYY', true)
                }
                return m.isValid() ? m.format('YYYY-MM-DD') : ''
            },

            getISODate(v) {
                if (!v) return '';
                const m = moment(v, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
                return m.isValid() ? m.format('YYYY-MM-DD') : '';
            },

            isAge14OrMore(v) {
                const iso = this.getISODate(v);
                if (!iso) return false;
                return moment().diff(moment(iso, 'YYYY-MM-DD', true), 'years') >= 14;
            },

            isEmailInterno(email) {
                if (!email) return false;
                const normalized = String(email).trim().toLowerCase();
                return this.emailsInternos.includes(normalized);
            },

            validarEmailInterno() {
                this.emailInternoConflito = false;
                if (this.alvo !== 'externo') return;

                if (this.isEmailInterno(this.novaPessoa.dsEmail)) {
                    this.emailInternoConflito = true;
                }
            },

            async enviar() {
                if (!this.checkForm()) return false;

                const clean = v => (v ?? '').toString().trim();

                const nrCpfCnpjNum = (this.novaPessoa.nrCpfCnpj || '').replace(/\D/g, '');
                const nrRgNum = (this.novaPessoa.nrRg || '').replace(/\D/g, '');
                const dtISO = this.getISODate(this.novaPessoa.dtNascimento);

                const dadosPessoa = {
                    ...(this.temPessoa && this.novaPessoa.idPessoa ? { idPessoa: this.novaPessoa.idPessoa } : {}),
                    dsLogin: this.dados?.dsLogin ?? null,
                    dsEmail: clean(this.novaPessoa.dsEmail),
                    nrCpfCnpj: nrCpfCnpjNum,
                    nrRg: nrRgNum,
                    nmPessoa: clean(this.novaPessoa.nmPessoa),
                    dtNascimento: dtISO,
                    nmCidade: clean(this.novaPessoa.nmCidade),
                    nmUf: clean(this.novaPessoa.nmUf).toUpperCase(),
                    nmPais: clean(this.novaPessoa.nmPais),
                };

                const payload = { DadosPessoa: dadosPessoa };

                try {
                    const { data } = await axios.post(`${urlApi}/Pessoa/Post`, payload);
                    if (data?.success) {
                        avisoSucesso('Dados salvos com sucesso!');
                        this.modal.hide();
                        this.$emit('reload');
                        this.$emit('close');
                        return true;
                    } else {
                        avisoErro(data?.msg || 'Não foi possível salvar os dados.');
                        return false;
                    }
                } catch (err) {
                    const msg = err?.response?.data?.msg
                        ? `${err.response.data.msg} ${err.response.data.errors?.[0] || ''}`
                        : (err?.response?.statusText || 'Erro ao salvar');
                    avisoErro(msg);
                    return false;
                }
            },

            maskCpfCnpj(value = '') {
                const cleaned = String(value).replace(/[^A-Za-z0-9]/g, '').toUpperCase();
                if (!cleaned) return '';

                const isCnpj = cleaned.length > 11 || /[A-Z]/.test(cleaned);

                if (!isCnpj) {
                    // CPF: 000.000.000-00
                    const digits = cleaned.slice(0, 11);
                    return digits
                        .replace(/(\d{3})(\d)/, '$1.$2')
                        .replace(/(\d{3})(\d)/, '$1.$2')
                        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
                }

                // CNPJ alfanumérico: AA.AAA.AAA/AAAA-00 (12 alfanuméricos + 2 dígitos verificadores)
                let base = '';
                let dv = '';
                let i;

                for (i = 0; i < cleaned.length && base.length < 12; i++) {
                    base += cleaned.charAt(i);
                }

                for (; i < cleaned.length && dv.length < 2; i++) {
                    if (/\d/.test(cleaned.charAt(i))) {
                        dv += cleaned.charAt(i);
                    }
                }

                let formatted = base.substring(0, 2);
                if (base.length > 2) formatted += '.' + base.substring(2, 5);
                if (base.length > 5) formatted += '.' + base.substring(5, 8);
                if (base.length > 8) formatted += '/' + base.substring(8, 12);
                if (dv.length > 0) formatted += '-' + dv;

                return formatted;
            },

            formatarCpfCnpj() {
                this.novaPessoa.nrCpfCnpj = this.maskCpfCnpj(this.novaPessoa.nrCpfCnpj);
            },

            validarRG(rg) {
                if (!rg) return false
                const clean = rg.replace(/[^\w]/g, '')
                return clean.length >= 5 && clean.length <= 12
            },

            sanitizarRg() {
                if (!this.novaPessoa.nrRg) return
                let v = this.novaPessoa.nrRg.replace(/[^\w]/g, '')
                if (v.length > this.rgMaxLength) v = v.slice(0, this.rgMaxLength)
                this.novaPessoa.nrRg = v
            },

            validarEmail(email) {
                const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                return re.test(email)
            },

            validarCpfCnpj(valor) {
                const v = valor.replace(/\D/g, '')
                if (v.length === 11) return this.validarCPF(v)
                if (v.length === 14) return this.validarCNPJ(v)
                return false
            },

            validarCPF(cpf) {
                if (!cpf || cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false
                let soma = 0
                for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i)
                let resto = (soma * 10) % 11
                if (resto === 10 || resto === 11) resto = 0
                if (resto !== parseInt(cpf.charAt(9))) return false
                soma = 0
                for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i)
                resto = (soma * 10) % 11
                if (resto === 10 || resto === 11) resto = 0
                return resto === parseInt(cpf.charAt(10))
            },

            validarCNPJ(cnpj) {
                if (!cnpj || cnpj.length !== 14) return false
                if (/^(\d)\1+$/.test(cnpj)) return false
                let tamanho = cnpj.length - 2
                let numeros = cnpj.substring(0, tamanho)
                let digitos = cnpj.substring(tamanho)
                let soma = 0
                let pos = tamanho - 7
                for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--
                    if (pos < 2) pos = 9
                }
                let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
                if (resultado != digitos.charAt(0)) return false
                tamanho += 1
                numeros = cnpj.substring(0, tamanho)
                soma = 0
                pos = tamanho - 7
                for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--
                    if (pos < 2) pos = 9
                }
                resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
                return resultado == digitos.charAt(1)
            },

            resetModal() {
                this.temPessoa = false
                this.abaModalAtiva = 'Cadastro'
                this.emailInternoConflito = false
                this.novaPessoa = {
                    idPessoa: null,
                    dsEmail: '',
                    nrCpfCnpj: '',
                    nrRg: '',
                    nmPessoa: '',
                    dtNascimento: '',
                    nmCidade: '',
                    nmUf: '',
                    nmPais: '',
                }
                this.camposInvalidos = {
                    dsEmail: false,
                    nrCpfCnpj: false,
                    nrRg: false,
                    nmPessoa: false,
                    dtNascimento: false,
                    nmCidade: false,
                    nmUf: false,
                    nmPais: false,
                }
            },

            setAba(aba) {
                if (aba === 'Certificados' && !this.temPessoa) {
                    // hard block
                    return;
                }
                this.abaModalAtiva = aba;
                if (aba === 'Certificados') {
                    this.fetchCertificados();
                }
            },

            checkForm() {
                let ok = true;
                const c = this.novaPessoa;
                this.camposInvalidos = {
                    dsEmail: false, nrCpfCnpj: false, nrRg: false,
                    nmPessoa: false, dtNascimento: false,
                    nmCidade: false, nmUf: false, nmPais: false
                };
                this.emailInternoConflito = false;

                const obrig = ['dsEmail', 'nrCpfCnpj', 'nrRg', 'nmPessoa', 'dtNascimento', 'nmCidade', 'nmUf', 'nmPais'];
                for (const k of obrig) {
                    if (!c[k] || String(c[k]).trim() === '') {
                        this.camposInvalidos[k] = true; ok = false;
                    }
                }

                if (ok && !this.validarEmail(c.dsEmail)) {
                    this.camposInvalidos.dsEmail = true; ok = false;
                    avisoErro('E-mail inválido.');
                }

                if (ok && this.alvo === 'externo' && this.isEmailInterno(c.dsEmail)) {
                    this.camposInvalidos.dsEmail = true;
                    this.emailInternoConflito = true;
                    ok = false;
                    avisoErro('Este e-mail já está cadastrado como um usuário do sistema. Para gerar o certificado, use a aba "Gerenciamento de Usuários".');
                }

                if (ok && !this.validarCpfCnpj(c.nrCpfCnpj)) {
                    this.camposInvalidos.nrCpfCnpj = true; ok = false;
                    avisoErro('CPF ou CNPJ inválido.');
                }

                const iso = this.getISODate(c.dtNascimento);
                if (ok && (!iso || !this.isAge14OrMore(iso))) {
                    this.camposInvalidos.dtNascimento = true; ok = false;
                    avisoErro('O usuário deve ter pelo menos 14 anos.');
                }

                if (!ok) {
                    avisoErro('Por favor, corrija os campos destacados.');
                    this.$nextTick(() => {
                        const first = document.querySelector('#CadastroCertificadoAssinatura .border-danger');
                        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    });
                }
                return ok;
            },


            async load() {
                if (this.alvo === 'externo' && !this.dados?.idPessoa) {
                    this.resetModal();
                    this.abaModalAtiva = 'Cadastro';
                    return;
                }

                if (this.alvo === 'externo' && this.dados?.idPessoa) {
                    const ok = await this.getPessoaById(this.dados.idPessoa);
                    this.abaModalAtiva = 'Cadastro';
                    return ok;
                }

                if (!this.dados || !this.dados.dsLogin) {
                    await this.getPessoaGnp();
                    this.abaModalAtiva = 'Cadastro';
                    return;
                }
                const hasPessoa = await this.getPessoa();
                if (!hasPessoa) await this.getPessoaGnp();
                this.abaModalAtiva = 'Cadastro';
            },


            getPessoa() {
                let $this = this;
                return axios.get(`${urlApi}/Pessoa/Get`, { params: { dsLogin: $this.dados.dsLogin } })
                    .then(res => {
                        if (!res.data?.success) {
                            $this.temPessoa = false
                            return false
                        }

                        const grid = res.data.data;
                        const first = grid?.rows?.[0]?.pessoa || null;

                        if (!first?.idPessoa) {
                            this.temPessoa = false;
                            return false;
                        }

                        this.novaPessoa = {
                            idPessoa: first.idPessoa ?? null,
                            dsEmail: first.dsEmail ?? '',
                            nrCpfCnpj: first.nrCpfCnpj ?? '',
                            nrRg: first.nrRg ?? '',
                            nmPessoa: first.nmPessoa ?? '',
                            dtNascimento: this.toISODateOnly(first.dtNascimento),
                            nmCidade: first.nmCidade ?? '',
                            nmUf: (first.nmUf ?? '').toUpperCase(),
                            nmPais: first.nmPais ?? '',
                        };
                        this.novaPessoa.nrCpfCnpj = this.maskCpfCnpj(this.novaPessoa.nrCpfCnpj);
                        this.temPessoa = true;
                        return true;
                    })
                    .catch(err => {
                        console.error('erro ao buscar pessoa:', err);
                        this.temPessoa = false;
                        return false;
                    });
            },

            getPessoaGnp() {
                let $this = this;
                return axios.get(`${urlApi}/ClienteContratoProduto/GetCadastroUsuarioCliente`, { params: this.dados })
                    .then(res => {
                        if (!res.data?.success || !res.data?.data) {
                            $this.temPessoa = false
                            return false
                        }

                        const result = res.data.data
                        const pc = result.pessoaCrud || {}
                        $this.novaPessoa = {
                            idPessoa: null,
                            dsEmail: pc.dsEmail || '',
                            nrCpfCnpj: pc.nrCpf || '',
                            nrRg: '',
                            nmPessoa: pc.nmPessoa || '',
                            dtNascimento: $this.toISODateOnly(pc.dtNascimento),
                            nmCidade: pc.nmCidade || '',
                            nmUf: (pc.nmUf || '').toUpperCase(),
                            nmPais: '',
                        }
                        $this.temPessoa = false
                        return true
                    })
                    .catch(err => {
                        console.error('erro ao buscar pessoa:', err)
                        $this.temPessoa = false
                        return false
                    });
            },

            getPessoaById(idPessoa) {
                return axios.get(`${urlApi}/Pessoa/Get`, { params: { idPessoa } })
                    .then(res => {
                        if (!res.data?.success || !res.data?.data) { this.temPessoa = false; return false; }

                        const grid = res.data.data;
                        const rows = grid?.rows || null;
                        const p = rows
                            ? (Array.isArray(rows) ? rows[0]?.pessoa || rows[0] : Object.values(rows)[0]?.pessoa || Object.values(rows)[0])
                            : (grid.pessoa || grid);

                        if (!p?.idPessoa) { this.temPessoa = false; return false; }

                        this.novaPessoa = {
                            idPessoa: p.idPessoa ?? null,
                            dsEmail: p.dsEmail ?? '',
                            nrCpfCnpj: this.maskCpfCnpj(p.nrCpfCnpj ?? ''),
                            nrRg: p.nrRg ?? '',
                            nmPessoa: p.nmPessoa ?? '',
                            dtNascimento: this.toISODateOnly(p.dtNascimento),
                            nmCidade: p.nmCidade ?? '',
                            nmUf: (p.nmUf ?? '').toUpperCase(),
                            nmPais: p.nmPais ?? '',
                        };
                        this.temPessoa = true;
                        return true;
                    })
                    .catch(() => { this.temPessoa = false; return false; });
            },

            fetchCertificados() {
                let $this = this;
                $this.isLoadingCerts = true;
                $this.certsError = null;

                return axios.get(`${urlApi}/Pessoa/GetCertificados`, {
                    params: { idPessoa: $this.novaPessoa.idPessoa }
                })
                    .then(res => {
                        const payload = res.data.data.result;
                        const rows = payload.rows;

                        $this.certificados = rows.map(r => {
                            const c = r.pessoaCertificado;
                            c.nmCriadoPor = r.criador.nmUsuario;
                            c.nmRevogadoPor = r.revogador ? r.revogador.nmUsuario : null;
                            return c;
                        });

                        return true;
                    })
                    .catch(err => {
                        console.error('erro ao buscar certificados:', err);
                        $this.certsError = err?.response?.data?.msg || 'Falha ao carregar certificados.';
                        $this.certificados = [];
                        return false;
                    })
                    .finally(() => {
                        $this.isLoadingCerts = false;
                    });
            },

            async gerarCertificado() {
                let $this = this;

                if ($this.hasCertAtivo) {
                    avisoErro('Já existe um certificado ativo para esta pessoa. Revogue-o antes de gerar outro.');
                    return;
                }

                if (!$this.temPessoa || !$this.novaPessoa.idPessoa) {
                    avisoErro('Cadastre/recupere a pessoa antes de gerar o certificado.');
                    return;
                }

                try {
                    $this.isGerandoCert = true;
                    const url = `${urlApi}/Pessoa/SalvarCertificadoPessoa`;
                    const body = $this.novaPessoa.idPessoa;
                    const { data } = await axios.post(url, body, {
                        headers: { 'Content-Type': 'application/json' }
                    });

                    if (data?.success) {
                        avisoSucesso(data.msg || 'Certificado gerado e salvo com sucesso.');
                        await $this.fetchCertificados();
                    } else {
                        avisoErro(data?.msg || 'Não foi possível gerar o certificado.');
                    }
                } catch (err) {
                    const msg = err?.response?.data?.msg
                        ? `${err.response.data.msg} ${err.response.data.errors?.[0] || ''}`
                        : (err?.response?.statusText || 'Erro ao gerar certificado');
                    avisoErro(msg);
                } finally {
                    $this.isGerandoCert = false;
                }
            },

            revogarCertificado(c) {
                if (!c || !c.idPessoaInstituicaoCertificado) {
                    avisoErro('Registro de certificado inválido.');
                    return false;
                }

                return Swal.fire({
                    title: 'Revogar certificado?',
                    html: `<p>Ao revogar este certificado, <strong>esta pessoa não poderá assinar nenhum documento</strong>
                            até que um novo certificado seja gerado.</p>
                           <p class="mb-0"><strong>Deseja continuar?</strong></p>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sim, revogar',
                    cancelButtonText: 'Cancelar',
                    reverseButtons: true,
                    focusCancel: true
                }).then((result) => {
                    if (!result.isConfirmed) return false;

                    this.isRevogandoId = c.idPessoaInstituicaoCertificado;

                    return axios.post(`${urlApi}/Pessoa/RevogarCertificadoPessoa`,
                        c.idPessoaInstituicaoCertificado,
                        { headers: { 'Content-Type': 'application/json' } }
                    )
                        .then(({ data }) => {
                            if (data?.success) {
                                avisoSucesso(data.msg || 'Certificado revogado com sucesso.');
                                return this.fetchCertificados();
                            } else {
                                avisoErro(data?.msg || 'Não foi possível revogar o certificado.');
                                return false;
                            }
                        })
                        .catch(err => {
                            const msg = err?.response?.data?.msg
                                ? `${err.response.data.msg} ${err.response.data.errors?.[0] || ''}`
                                : (err?.response?.statusText || 'Erro ao revogar certificado');
                            avisoErro(msg);
                            return false;
                        })
                        .finally(() => {
                            this.isRevogandoId = null;
                        });
                });
            },

            formatDate(v) {
                if (!v) return '-';
                const m = moment(v, [moment.ISO_8601, 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
                return (m.isValid() ? m.format('DD/MM/YYYY') : '-');
            },

            formatDateTime(v) {
                if (!v) return '-';
                const m = moment(v, [moment.ISO_8601, 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm'], true);
                return (m.isValid() ? m.format('DD/MM/YYYY HH:mm') : '-');
            },


            close() {
                //const myModalAlternative = new window.bootstrap.Modal('#CadastroCertificadoAssinatura');
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalCadastroCertificadoAssinatura);
                }
                this.modal.hide();
            }

        },
        mounted() {
            const esperaBoootstrap = () => {
                if (window.bootstrap && window.bootstrap.Modal) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalCadastroCertificadoAssinatura);
                } else {
                    setTimeout(esperaBoootstrap, 50)
                }
            }
            this.$nextTick(() => esperaBoootstrap());
        },
        watch: {
            async showModal() {
                //const myModalAlternative = new window.bootstrap.Modal('#CadastroCertificadoAssinatura');
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalCadastroCertificadoAssinatura);
                }
                this.modal.show();

                this.resetModal();
                //this.myModalAlternative.show();
                await this.load();
                if (!this.temPessoa) this.abaModalAtiva = 'Cadastro';
            },
            temPessoa(nv) {
                if (!nv && this.abaModalAtiva === 'Certificados') {
                    this.abaModalAtiva = 'Cadastro';
                }
            },
            abaModalAtiva(nv) {
                if (nv === 'Certificados' && !this.temPessoa) {
                    this.abaModalAtiva = 'Cadastro';
                }
            }
        }
    };
</script>

<style scoped>
    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        z-index: 10;
    }

    .btn-close-modern:hover {
        transform: scale(1.05);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
    }

    .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .modal-modern-header .header-icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
        color: #2563eb;
    }

    .modal-modern-header .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .modal-modern-header .header-text p {
        margin-top: 6px;
        margin-bottom: 0;
        color: #475569;
        font-size: 14px;
        max-width: 460px;
        line-height: 1.4;
    }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        flex: 1 1 auto;
        overflow-y: auto;
    }

    .tab-wrapper {
        display: flex;
        flex-direction: column;
        gap: 24px;
        min-height: 0;
    }
    .certificados-wrapper {
        width: 100%;
        overflow-x: hidden;
    }


    .cadastro-card {
        background: linear-gradient(135deg, rgba(248, 250, 252, 0.85) 0%, rgba(255, 255, 255, 0.92) 100%);
        border: 1px solid rgba(229, 231, 235, 0.9);
        border-radius: 18px;
        padding: 24px 26px;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .modal-form {
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
    }

    .modern-modal .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .modern-modal .form-control:focus {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
        background: #ffffff;
    }

    .modern-modal select.form-control {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .modern-modal .form-control::placeholder {
        color: #94a3b8;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-modern-primary {
        color: white;
        border: none;
        border-radius: 12px;
        padding: 14px 20px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-modern-primary:hover {
        transform: translateY(-2px);
        box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
    }

    .btn-modern-primary:active {
        transform: translateY(0);
    }

    .border-danger {
        border-color: #E8B6C1 !important;
        box-shadow: 0 0 0 0.2rem rgba(196, 104, 110, 0.25);
    }

    .nav-tabs {
        display: flex;
        gap: 0.5rem;
        border-bottom: none;
        background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(237, 242, 247, 0.9) 100%);
        border-radius: 14px;
        padding: 0.75rem;
        box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.6);
    }

    .nav-tabs + .cadastro-card,
    .nav-tabs + .certificados-wrapper {
        margin-top: 6px;
    }

    .nav-tabs .nav-link {
        border: 1px solid transparent;
        background: rgba(248, 250, 252, 0.75);
        color: #475569;
        font-weight: 600;
        padding: 0.65rem 1.35rem;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        transition: all 0.2s ease;
        box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.7);
    }

    .nav-tabs .nav-link:hover {
        background: rgba(37, 99, 235, 0.08);
        color: #2563EB;
        box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.25);
    }

    .nav-tabs .nav-link.active {
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        color: #ffffff;
        box-shadow: 0 10px 24px rgba(37, 99, 235, 0.25);
        border: none;
    }

    .nav-tabs .nav-link.disabled {
        opacity: 0.55;
        cursor: not-allowed !important;
        pointer-events: auto;
    }

    [data-bs-theme="dark"] .nav-tabs {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.92) 100%);
        box-shadow: inset 0 0 0 1px rgba(71, 85, 105, 0.5);
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link {
        background: rgba(30, 41, 59, 0.85);
        color: #cbd5f5;
        box-shadow: inset 0 0 0 1px rgba(71, 85, 105, 0.45);
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link:hover {
        background: rgba(59, 130, 246, 0.22);
        color: #93c5fd;
        box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.35);
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link.active {
        background: linear-gradient(135deg, #2563EB 0%, #16a34a 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-body {
        background: transparent;
    }

    [data-bs-theme="dark"] .cadastro-card {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.75) 0%, rgba(17, 24, 39, 0.85) 100%);
        border-color: rgba(71, 85, 105, 0.6);
        box-shadow: 0 18px 48px rgba(2, 6, 23, 0.55);
    }

    [data-bs-theme="dark"] .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.25);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-control:focus {
        background: rgba(15, 23, 42, 0.95);
    }

    [data-bs-theme="dark"] .modern-modal .form-control::placeholder {
        color: #64748b;
    }

    .btn-fluxo.btn-acoes[disabled] {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .section-card h3 {
        margin-bottom: .5rem !important;
    }

    .cert-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 20px;
    }

    .cert-card {
        border: 2px solid #e5e7eb;
        border-radius: 16px;
        padding: 0;
        background: #fff;
        transition: all 0.3s ease;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        width: 100%;
        box-sizing: border-box;
    }

    .cert-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    }

    [data-bs-theme="dark"] .cert-card {
        background: #111827;
        border-color: #374151;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .cert-card:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
    }

    /* Card ativo - borda verde */
    .cert-card.ativo {
        border-color: #10b981;
        box-shadow: 0 2px 12px rgba(16, 185, 129, 0.15);
    }

    .cert-card.ativo:hover {
        box-shadow: 0 4px 20px rgba(16, 185, 129, 0.25);
    }

    /* Card inativo/revogado - borda vermelha */
    .cert-card:not(.ativo) {
        border-color: #fca5a5;
        box-shadow: 0 2px 12px rgba(239, 68, 68, 0.1);
    }

    .cert-card:not(.ativo):hover {
        box-shadow: 0 4px 20px rgba(239, 68, 68, 0.15);
    }

    [data-bs-theme="dark"] .cert-card:not(.ativo) {
        border-color: #991b1b;
    }

    .cert-card-header {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        padding: 16px 20px;
        border-bottom: 2px solid #e5e7eb;
    }

    [data-bs-theme="dark"] .cert-card-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    /* Header do card ativo */
    .cert-card.ativo .cert-card-header {
        background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
        border-bottom-color: #10b981;
    }

    [data-bs-theme="dark"] .cert-card.ativo .cert-card-header {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%);
        border-bottom-color: #10b981;
    }

    /* Header do card inativo/revogado */
    .cert-card:not(.ativo) .cert-card-header {
        background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
        border-bottom-color: #fca5a5;
    }

    [data-bs-theme="dark"] .cert-card:not(.ativo) .cert-card-header {
        background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
        border-bottom-color: #991b1b;
    }

    .cert-icon {
        font-size: 20px;
    }

    .badge-status {
        padding: 6px 14px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .badge-status-active {
        background: #10b981;
        color: white;
    }

    .badge-status-revoked {
        background: #6b7280;
        color: white;
    }

    .btn-revogar {
        background: #ef4444;
        color: white;
        border: none;
        padding: 6px 16px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .btn-revogar:hover:not(:disabled) {
        background: #dc2626;
        transform: scale(1.05);
    }

    .btn-revogar:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .cert-fields {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 20px;
        row-gap: 14px;
        padding: 20px;
    }

    .cert-fields .pair {
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .cert-fields .pair-full {
        grid-column: 1 / -1;
    }

    .cert-fields .lbl {
        color: #6b7280;
        display: flex;
        align-items: center;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    [data-bs-theme="dark"] .cert-fields .lbl {
        color: #9ca3af;
    }

    /* Ícones coloridos sutis para melhor identificação visual */
    .cert-fields .lbl .fa-user {
        color: #a78bfa;
    }

    .cert-fields .lbl .fa-envelope {
        color: #60a5fa;
    }

    .cert-fields .lbl .fa-id-card,
    .cert-fields .lbl .fa-address-card {
        color: #fbbf24;
    }

    .cert-fields .lbl .fa-calendar {
        color: #22d3ee;
    }

    .cert-fields .lbl .fa-map-marker-alt,
    .cert-fields .lbl .fa-city {
        color: #f472b6;
    }

    .cert-fields .lbl .fa-globe {
        color: #34d399;
    }

    .cert-fields .pair-meta .lbl .fa-user-plus {
        color: #3b82f6;
    }

    .cert-fields .pair-meta .lbl .fa-user-times {
        color: #ef4444;
    }

    .cert-fields .val {
        font-weight: 600;
        font-size: 14px;
        color: #111827;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    [data-bs-theme="dark"] .cert-fields .val {
        color: #f9fafb;
    }

    .cert-fields .pair-full .val {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .cert-divider {
        grid-column: 1 / -1;
        height: 1px;
        background: linear-gradient(90deg, transparent 0%, #e5e7eb 50%, transparent 100%);
        margin: 6px 0;
    }

    [data-bs-theme="dark"] .cert-divider {
        background: linear-gradient(90deg, transparent 0%, #374151 50%, transparent 100%);
    }

    .cert-fields .pair-meta {
        padding: 12px;
        border-radius: 8px;
        border: 1px solid #e5e7eb;
        background: #f9fafb;
    }

    [data-bs-theme="dark"] .cert-fields .pair-meta {
        background: #1f2937;
        border-color: #374151;
    }

    .cert-fields .val-meta {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .cert-fields .meta-name {
        font-weight: 600;
        font-size: 14px;
        color: #111827;
    }

    [data-bs-theme="dark"] .cert-fields .meta-name {
        color: #f9fafb;
    }

    /* Nome do usuário que criou - azul */
    .cert-fields .pair-meta:not(:has(.lbl .fa-user-times)) .meta-name {
        color: #2563eb;
    }

    [data-bs-theme="dark"] .cert-fields .pair-meta:not(:has(.lbl .fa-user-times)) .meta-name {
        color: #60a5fa;
    }

    /* Nome do usuário que revogou - vermelho */
    .cert-fields .pair-meta:has(.lbl .fa-user-times) .meta-name {
        color: #dc2626;
    }

    [data-bs-theme="dark"] .cert-fields .pair-meta:has(.lbl .fa-user-times) .meta-name {
        color: #f87171;
    }

    .cert-fields .meta-date {
        font-size: 12px;
        color: #6b7280;
        font-weight: 500;
    }

    [data-bs-theme="dark"] .cert-fields .meta-date {
        color: #9ca3af;
    }

    #CadastroCertificadoAssinatura .modal-dialog {
        max-height: 95vh;
    }

    #CadastroCertificadoAssinatura .modal-content {
        max-height: 95vh;
        display: flex;
        flex-direction: column;
    }

    #CadastroCertificadoAssinatura .modal-body {
        overflow: auto;
    }

    /* Responsividade */
    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

        .modal-modern-header::after {
            left: 20px;
            right: 20px;
        }

        .modal-modern-header .header-icon {
            width: 56px;
            height: 56px;
        }

        .cadastro-card {
            padding: 20px 18px;
        }

        .cert-grid {
            grid-template-columns: 1fr;
            gap: 16px;
        }

        .cert-fields {
            padding: 16px;
            row-gap: 12px;
        }

        .cert-card-header {
            padding: 14px 16px;
        }

        .btn-revogar {
            padding: 5px 12px;
            font-size: 12px;
        }
    }

    @media (max-width: 576px) {
        .modern-modal .modal-dialog {
            margin: 12px;
        }

        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }
    }

    @media (min-width: 769px) and (max-width: 1200px) {
        .cert-grid {
            grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
        }
    }

    @media (min-width: 1600px) {
        .cert-grid {
            grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
        }
    }

</style>

